var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useEntityInfiniteScrollQuery } from '../hooks/use-entity-infinite-scroll-query';
import { OptionMenuInput } from './option-menu-input';
import { OptionMenuItemEntityValueCheckbox } from './option-menu-item-entity-value-checkbox';
import { OptionMenuInputPlaceholderEntityValue } from './option-menu-input-placeholder-entity-value';
import { OptionMenuInputPlaceholderEntityValueSlim } from './option-menu-input-placeholder-entity-value-slim';
import { OptionMenuItemEntityValue } from './option-menu-item-entity-value';
import { compact, startCase } from 'lodash';
import pluralize from 'pluralize';
import { entityFromOptionMenuItem } from './utils/entity-from-option-menu-item';
import { OptionMenuItemEntityValueSlim } from './option-menu-item-entity-value-slim';
import { OptionMenuItemEntityValueCheckboxSlim } from './option-menu-item-entity-value-checkbox-slim';
var cls = classNames('entity-type-select');
var EntityTypeSelectOptionMenuComponents = {
  default: OptionMenuItemEntityValue,
  slim: OptionMenuItemEntityValueSlim
};
var EntityTypeSelectOptionMenuComponentsMultiple = {
  default: OptionMenuItemEntityValueCheckbox,
  slim: OptionMenuItemEntityValueCheckboxSlim
};
var EntityTypeSelectOptionMenuInputPlaceholderComponents = {
  default: OptionMenuInputPlaceholderEntityValue,
  slim: OptionMenuInputPlaceholderEntityValueSlim
};
var EntityTypeSelectOptionMenuInputSelectedItemComponents = {
  default: OptionMenuItemEntityValue,
  slim: OptionMenuItemEntityValueSlim
};
export var EntityTypeSelectDefaultProps = {
  variant: 'default',
  infiniteScrollProps: {
    requiresAuthentication: false,
    itemsPerPage: 20,
    fetchPolicy: 'cache-first',
    orderBy: [{
      fieldName: 'name'
    }],
    notifyOnNetworkStatusChange: true
  },
  allowMultipleSelections: false,
  allowSorting: true,
  requiresAuthentication: false,
  optionMenuInputProps: {
    // bodyProps: {
    //   borderWidth: 0,
    //   style: {
    //     boxShadow: 'none',
    //     outline: 'none',
    //   }
    // }
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border: none;\n  "], ["\n    border: none;\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'EntityTypeSelect',
  Container: styled(OptionMenuInput)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
var entityToOptionMenuItem = function (entity) {
  return {
    id: entity.id,
    label: entity.name,
    data: {
      entity: entity
    }
  };
};
export var EntityTypeSelect = function (props) {
  var componentProps = useComponentProps(My.NAME, EntityTypeSelectDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    entityTypeName = componentProps.entityTypeName,
    variant = componentProps.variant,
    infiniteScrollProps = componentProps.infiniteScrollProps,
    allowSorting = componentProps.allowSorting,
    optionMenuInputProps = componentProps.optionMenuInputProps;
  var id = props.id || "entity-select-".concat(entityTypeName);
  var selectedItems = compact(props.selectedItems || []).map(entityToOptionMenuItem);
  var selectedItem = props.selectedItem ? entityToOptionMenuItem(props.selectedItem) : undefined;
  var _a = __read(React.useState(''), 2),
    inputValue = _a[0],
    setInputValue = _a[1];
  var allowMultipleSelections = props.allowMultipleSelections === undefined ? props.selectedItems !== undefined : props.allowMultipleSelections;
  var singularLabel = props.label || startCase(entityTypeName);
  var pluralLabel = pluralize(singularLabel);
  var label = props.label || (allowMultipleSelections ? pluralLabel : singularLabel);
  var placeholder = props.placeholder === undefined ? allowMultipleSelections ? 'Select items...' : "Select an item..." : props.placeholder;
  var filter = inputValue ? {
    _optionLabel: {
      contains: inputValue
    }
  } : undefined;
  // Pull infinite scroll properties to feed into the menu (for pagination)
  var infiniteScroll = useEntityInfiniteScrollQuery(__assign(__assign({}, infiniteScrollProps), {
    entityTypeName: entityTypeName,
    filter: filter
  }));
  // create menu structure out of the current set of items
  var items = infiniteScroll.items;
  var menu = {
    id: id,
    items: items.map(entityToOptionMenuItem)
  };
  var OptionItemComponent = allowMultipleSelections ? EntityTypeSelectOptionMenuComponentsMultiple[variant] || OptionMenuItemEntityValueCheckbox : EntityTypeSelectOptionMenuComponents[variant] || OptionMenuItemEntityValue;
  var SelectedItemComponent = EntityTypeSelectOptionMenuInputSelectedItemComponents[variant] || OptionMenuItemEntityValue;
  var PlaceholderComponent = EntityTypeSelectOptionMenuInputPlaceholderComponents[variant] || OptionMenuInputPlaceholderEntityValue;
  var menuProps = {
    // todo - allow option items to be configured
    itemComponent: OptionItemComponent,
    infiniteScroll: infiniteScroll
  };
  var handleSelect = function (args) {
    var _a;
    var item = args.item,
      _b = args.items,
      items = _b === void 0 ? [] : _b;
    (_a = props.onSelect) === null || _a === void 0 ? void 0 : _a.call(props, {
      item: entityFromOptionMenuItem(item),
      items: items.map(entityFromOptionMenuItem)
    });
    // hides the menu on select if this is a single item select
    return !allowMultipleSelections;
  };
  return React.createElement(My.Container, __assign({}, optionMenuInputProps, {
    label: label,
    onChange: function (_a) {
      var value = _a.value;
      return setInputValue(value);
    },
    className: cls.name(className),
    menu: menu,
    placeholder: placeholder,
    onSelect: handleSelect,
    selectedItems: selectedItems,
    selectedItem: selectedItem,
    applyFilter: false,
    selectedItemComponent: SelectedItemComponent,
    placeholderComponent: PlaceholderComponent,
    allowMultipleSelections: allowMultipleSelections,
    allowSorting: allowSorting,
    inputValue: inputValue,
    showMenuIndicator: true,
    isLoading: infiniteScroll.loading,
    menuProps: menuProps
  }));
};
EntityTypeSelect.cls = cls;
var templateObject_1, templateObject_2;